import type { CropsType, ImageSize, PossibleCrops, ProcessingConfig } from './models/processing-config.model';

/**
 * This Function is used to extract crops from images provided by the CMS
 * If you only have Pictures and want to process them, you do not need this!
 * @param availableCrops
 * @param desiredCrop
 * @param size
 */
export function buildConfigForInfomakerImage(
  availableCrops: CropsType,
  desiredCrop: PossibleCrops,
  size: ImageSize
): ProcessingConfig {
  // if we get defined crops but the desired one is not set: use 4:3 as desired one
  if (availableCrops && !desiredCrop) {
    desiredCrop = '4:3';
  }
  // if the desired one is not present use no-crop
  desiredCrop = availableCrops?.[desiredCrop] ? desiredCrop : 'no-crop';

  const processConfig: ProcessingConfig = {
    resize: { ...processSize(desiredCrop, size), fit: 'cover' },
  };

  if (availableCrops?.[desiredCrop]) {
    const cropInfo: string[] = availableCrops[desiredCrop].split('/');
    processConfig.crop = {
      type: 'percent',
      left: parseCropInfoIntoNumber(cropInfo[0]),
      top: parseCropInfoIntoNumber(cropInfo[1]),
      width: parseCropInfoIntoNumber(cropInfo[2]),
      height: parseCropInfoIntoNumber(cropInfo[3]),
    };
  }

  if (desiredCrop === 'no-crop') {
    processConfig.resize.fit = 'inside';
  }

  return processConfig;
}

function parseCropInfoIntoNumber(val: string): number {
  const result = Number(val);

  if (result < 0) {
    return 0;
  }

  if (result > 1) {
    return 1;
  }

  return result;
}

// we're writing the second attribute whenever possible because
// the NgOptimizedImage directive seems to need both values
function processSize(desiredCrop: PossibleCrops, size: ImageSize): ImageSize {
  if (size.width && size.height) {
    return size;
  }
  if (desiredCrop === 'no-crop') {
    return size;
  }

  return !size.height ? fixHeight(desiredCrop, size) : fixWidth(desiredCrop, size);
}

function fixWidth(desiredCrop: PossibleCrops, size: ImageSize): ImageSize {
  size.width = null;
  if (desiredCrop === 'Header' || desiredCrop === '16:9') {
    size.width = Math.round(size.height * 1.7777);
  } else if (desiredCrop === '4:3') {
    size.width = Math.round(size.height * 1.3333);
  } else if (desiredCrop === '1:1') {
    size.width = size.height;
  } else if (desiredCrop === '2:1') {
    size.width = size.height * 2;
  } else if (desiredCrop === '1:2') {
    size.width = size.height / 2;
  }
  return size;
}
function fixHeight(desiredCrop: PossibleCrops, size: ImageSize): ImageSize {
  size.height = null;
  if (desiredCrop === 'Header' || desiredCrop === '16:9') {
    size.height = Math.round(size.width / 1.7777);
  } else if (desiredCrop === '4:3') {
    size.height = Math.round(size.width / 1.3333);
  } else if (desiredCrop === '1:1') {
    size.height = size.width;
  } else if (desiredCrop === '2:1') {
    size.height = size.width / 2;
  } else if (desiredCrop === '1:2') {
    size.height = size.width * 2;
  }
  return size;
}
